import React from "react";
import { Box, Button, Typography } from "@mui/material";
import CustomModal from "./CustomModal";

interface ViewSignatureModalProps {
  open: boolean;
  onClose: () => void;
  onEdit: () => void;
  signatureUrl: string | null;
}

export const ViewSignatureModal: React.FC<ViewSignatureModalProps> = ({
  open,
  onClose,
  onEdit,
  signatureUrl,
}) => {
  return (
    <CustomModal
      open={open}
      onClose={onClose}
      title="Assinatura"
      actions={
        <>
          <Button onClick={onEdit} variant="contained" color="primary">
            Editar Assinatura
          </Button>
          <Button onClick={onClose} variant="outlined">
            Fechar
          </Button>
        </>
      }
    >
      {signatureUrl ? (
        <Box sx={{ textAlign: "center", mt: 2 }}>
          <Typography variant="subtitle1" sx={{ mb: 2 }}>
            Sua assinatura atual:
          </Typography>
          <img
            src={signatureUrl}
            alt="Assinatura"
            style={{ maxWidth: "100%", maxHeight: "200px", border: "1px solid #ddd" }}
          />
        </Box>
      ) : (
        <Typography>Nenhuma assinatura cadastrada</Typography>
      )}
    </CustomModal>
  );
};